import React from 'react'

import NavBar from '../NavBar'
import SideDrawer from '../SideDrawer/SideDrawer'

const Nav: React.FC = () => {
    // const [open, setOpen] = React.useState(false)

    // const handleToggleDrawer = (): void => setOpen(!open)

    return (
        <>
            <NavBar />
            <SideDrawer />
        </>
    )
}

export default Nav
